var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcDownloadLined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.24745 11.966C8.17688 12.0382 8.08016 12.079 7.97916 12.079C7.87816 12.079 7.78143 12.0382 7.71087 11.966L5.23171 9.42731C5.08701 9.27914 5.08983 9.04172 5.238 8.89702C5.38617 8.75232 5.62359 8.75513 5.76829 8.9033L7.60416 10.7832V3C7.60416 2.79289 7.77205 2.625 7.97916 2.625C8.18626 2.625 8.35416 2.79289 8.35416 3V10.7832L10.19 8.9033C10.3347 8.75513 10.5721 8.75232 10.7203 8.89702C10.8685 9.04172 10.8713 9.27914 10.7266 9.42731L8.24745 11.966ZM3 13.625C2.79289 13.625 2.625 13.7929 2.625 14C2.625 14.2071 2.79289 14.375 3 14.375H13C13.2071 14.375 13.375 14.2071 13.375 14C13.375 13.7929 13.2071 13.625 13 13.625H3Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDownloadLined);
export default __webpack_public_path__ + "static/media/ic_download_lined.953f523062daa7e6d5a0070c8b7b5572.svg";
export { ForwardRef as ReactComponent };